import { motion } from 'framer-motion';
import { RebuildLogo } from './RebuildLogo';

const pageVariants = {
  initial: { opacity: 0, y: 10 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -10 }
};

export const PageWrapper = ({ children, className = '', hideTitle = false }) => {
  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.3, ease: 'easeOut' }}
      className={`h-screen w-full max-w-full flex flex-col overflow-y-auto overflow-x-hidden ${className}`}
    >
      {!hideTitle && (
        <div className="logo-area flex-shrink-0">
          <div className="max-w-md mx-auto w-full px-6 pt-4 pb-1 flex justify-center">
            <RebuildLogo scale={1.02} />
          </div>
        </div>
      )}
      <div
        className="content-area flex-grow"
        style={{ paddingBottom: 'calc(5.5rem + env(safe-area-inset-bottom, 0px))' }}
      >
        {children}
      </div>
    </motion.div>
  );
};

export default PageWrapper;